'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * VineEmbed
     *
     * This web component will lazy-load wrapped Vine embeds. Once an
     * embed is scrolled into view. It also checks the GDPR status.
     */
    class VineEmbed extends pageClass.PhoenixElement {
        connectedCallback() {
            this.src = this.getAttr('src', { required: true });

            this.canRender().then((canRender) => {
                if (canRender) {
                    this.observeFirstIntersection();
                } else {
                    // Make CSS show the fallback markup
                    this.classList.add('mm-custom-element--fallback');
                }
            });
        }

        onFirstIntersection() {
            pageClass.util
                .addScriptResourceOnce('https://platform.vine.co/static/scripts/embed.js', {
                    id: 'vine-embed-script',
                })
                .then(() => {
                    this.innerHTML = `<iframe class="m-video--frame"
                    src="${this.src}" height="600" width="600"
                    frameborder="0"></iframe>`;
                    // The Vine script lacks an API to notify of new embeds added to the
                    // DOM. But tests show that the script can find the new iframes, and
                    // manage the muted autoplay.
                });
        }
    }
    window.customElements.define('phoenix-vine-embed', VineEmbed);
});
